import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { DoctorsService } from '../../../services/doctors.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { PatientEditComponent } from '../../patient/patient-edit/patient-edit.component';
import { PatientService } from '../../patient/patient.service';
import { PatientDialogDataModel } from '../../patient/patient-dialog-data.model';
import { DoctorDataModel } from '../../../models/doctors/doctor-data.model';
import { TdoClientConfigurationModel } from '../../../models/clients/tdo-client-configuration.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DoctorSpecialtyDataModel } from '../../../models/doctors/doctor-specialty-data.model';
import { DoctorLocationDataModel } from '../../../models/doctors/doctor-location-data.model';
import { EnumValidValueItemModel } from '../../../models/enum/enum-valid-value-item.model';
import { ClientLocationDataModel } from '../../../models/clients/client-location-data.model';
import { DoctorLicenseDataModel } from '../../../models/doctors/doctor-license-data.model';
import { ContactDataModel } from '../../../models/person/contact-data.model';
import { TdoTableEvent } from '../../../tdo-controls/common/tdo-table/models/tdo-table.event';
import { DialogService } from '../../../services/dialog.service';
import { TdoUserConfigurationModel } from '../../../models/configuration/user/tdo-user-configuration.model';
import { UserService } from '../../../services/user.service';
import { Globals } from '../../../globals';
import { StaticDataService } from '../../../services/static-data.service';
import { TdoTableRowModel } from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-row.model';
import { TdoTableV2Component } from '../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import { TdoTableSelectionEvent } from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {
    DoctorConfigurationSaveRequirementsDialogComponent
} from './dialogs/doctor-configuration-save-requirements-dialog/doctor-configuration-save-requirements-dialog.component';
import { DoctorSaveValidationModel } from './models/doctor-save-validation.model';
import { DocumentUploadModel } from '../../../models/document/document-upload.model';
import { DocumentClassEnum } from '../../../models/enum/document/document-class.enum';
import { DocumentTypeEnum } from '../../../models/enum/document/document-type.enum';
import { FileHelperService } from '../../../services/file-helper.service';
import { DocumentFileTypeEnum } from '../../../models/enum/document/document-file-type.enum';
import { DocumentDataModel } from '../../../models/document/document-data.model';
import { FileManagerService } from '../../file-manager/file-manager.service';
import { ArAccountConfigurationModel } from '../../../models/doctors/ar-account-configuration.model';
import { MatSelectChange } from '@angular/material/select';
import { DoctorArLocationDataModel } from '../../../models/doctors/doctor-ar-location-data.model';
import { DoctorQueryOptionsModel } from '../../../models/doctors/doctor-query-options.model';
import {
    DoctorConfigurationAfterSaveWarningDialogComponent
} from './dialogs/doctor-configuration-after-save-warning-dialog/doctor-configuration-after-save-warning-dialog.component';
import { ActivatedRoute } from '@angular/router';
import { MatCheckboxChange } from '@angular/material/checkbox';
// import DevExpress from 'devextreme';
// import dialog = DevExpress.ui.dialog;
import { ContactCommsDataModel } from '../../../models/person/contact-comms-data.model';
import { CommMethodEnum } from 'src/app/models/enum/comm-method.enum';
import { CommLocationEnum } from 'src/app/models/enum/comm-location.enum';
import { DoctorType_Provider, DoctorType_Referring, ArIntegration_QuickBooks } from 'src/app/constants';
import { DoctorArLocationQuickbooksModel } from '../../../models/doctors/doctor-ar-location-quickbooks.model';
import {
    DoctorArLocationPaymentProcessorModel
} from '../../../models/doctors/doctor-ar-location-payment-processor.model';
import { CfgARPaymentProcessorModel } from '../../../models/accountsReceivable/cfg-ar-payment-processor.model';
import { EnumPaymentProcessorModel } from '../models/enum-payment-processor.model';



@Component({
    selector: 'app-doctors',
    templateUrl: './doctors.component.html',
    styleUrls: ['./doctors.component.scss']
})
export class DoctorsComponent implements OnInit {
    @ViewChild('doctorTable') doctorTable: TdoTableV2Component;
    @ViewChild('licenseTable') tdoTable: TdoTableV2Component;
    @ViewChild('fileInput') fileInput: ElementRef;

    filetypes = 'image/png, image/jpeg';

    // Table
    locationList: ClientLocationDataModel[];

    // Doctor
    doctorList: DoctorDataModel[];
    selectedDoctorLocationsByDay: DoctorLocationDataModel[];
    selectedDoctor: DoctorDataModel;
    selectedDoctorSpecialties: DoctorSpecialtyDataModel[];
    doctorLicenseList: DoctorLicenseDataModel[];
    doctorContactList: ContactDataModel[];
    lastSelectedRow: DoctorDataModel;
    isNewDoctor: boolean = false;
    selectedDoctorARLocation: DoctorArLocationDataModel;
    selectedArAccountConfig: ArAccountConfigurationModel;
    selectedArCheckAccountConfig: ArAccountConfigurationModel;
    selectedEnumARSystemIntegrationID: string;

    // Integrations
    isQuickbooksIntegration: boolean;
    selectedQuickBooks: DoctorArLocationQuickbooksModel;
    selectedQBSalesAccount: ArAccountConfigurationModel;
    selectedQBCheckingAccount: ArAccountConfigurationModel;

    // Client
    clientList: TdoClientConfigurationModel[];
    selectedClient: TdoClientConfigurationModel;
    selectedClientLocation: ClientLocationDataModel;
    allClientsLocations: ClientLocationDataModel[];
    userList: TdoUserConfigurationModel[];

    // Enums
    specialtyEnumList: EnumValidValueItemModel[];
    weekDaysEnumList: EnumValidValueItemModel[];
    doctorTypeEnumList: EnumValidValueItemModel[];
    arIntegrationEnumList: EnumValidValueItemModel[];
    isLoading = true;
    isResettingCredentials = false;


    // payment methods
    doctorArLocationPaymentProcessors: DoctorArLocationPaymentProcessorModel[];
    cfgARPaymentProcessors: CfgARPaymentProcessorModel[];

    // referral
    refDoctorTypesList: any[] = [
        { enumDoctorTypeID: '00000004-1000-0000-0000-000000000002', ItemDisplayValue: 'Referral (From)' },
        { enumDoctorTypeID: '00000004-1000-0000-0000-000000000004', ItemDisplayValue: 'Referral (To)' },
        { enumDoctorTypeID: '00000004-1000-0000-0000-000000000005', ItemDisplayValue: 'Referral (From and To)' },
    ];




    // Selected
    selectedWeekDays = [];
    selectedDoctorsSpecialtyEnumList: string[] = [];
    selectedARIntegrationEnumList: string = '';

    stateEnums: EnumValidValueItemModel[];
    licenseLocationList: ClientLocationDataModel[];

    unsavedChangesMessage = 'You have unsaved changes. Press ok to discard changes, or cancel and save your changes...';
    lastSelectedLogoPropertyName = '';
    signatureDocument: DocumentDataModel;
    portraitDocument: DocumentDataModel;
    arConfigurationAccounts: ArAccountConfigurationModel[] = [];
    selectedArAccountConfiguration: ArAccountConfigurationModel;
    selectedCheckAccountConfiguration: ArAccountConfigurationModel;

    searchPredicate: (data: any, filter: string) => boolean;
    sortPredicate: (data: any, sortHeaderId: string) => string;

    routeParamsDoctorTypeProviders = 'providers';
    // Can be provider or other
    doctorType: string = this.routeParamsDoctorTypeProviders;

    // is coming from FrontDesk Referral
    isFrontDeskReferral: boolean = false;
    colspan: number = 7;
    referralName: string;
    referralLastName: string;
    referralPhone: string;
    referralEmail: string;

    selected: number;
    isPaymentProcessorVisible: boolean = false;
    selectedPaymentProcessor: CfgARPaymentProcessorModel;
    initialDoctor: DoctorDataModel;

    constructor(
        private readonly doctorService: DoctorsService,
        private readonly dialog: MatDialog,
        private readonly patientService: PatientService,
        private readonly snackBar: MatSnackBar,
        private readonly dialogService: DialogService,
        private readonly userService: UserService,
        private readonly globals: Globals,
        private readonly staticDataService: StaticDataService,
        private readonly fileManagerService: FileManagerService,
        private readonly route: ActivatedRoute,
        public dialogRef: MatDialogRef<DoctorsComponent>
    ) {



    }



    ngOnInit() {

        this.doctorArLocationPaymentProcessors = [
            { LocPaymentProcessorId: '1', DoctorARLocId: '1', PaymentProcessorId: '1', PaymentProcessorName: 'Processor D1 M1', xauditDeleted: false, xauditCreatedBy: 'a', xauditCreatedOn: new Date(), xauditTableRowID: '', xauditModifiedBy: '', xauditModifiedOn: new Date() },
            { LocPaymentProcessorId: '1', DoctorARLocId: '1', PaymentProcessorId: '1', PaymentProcessorName: 'Processor D1 M2', xauditDeleted: false, xauditCreatedBy: 'a', xauditCreatedOn: new Date(), xauditTableRowID: '', xauditModifiedBy: '', xauditModifiedOn: new Date() },
            { LocPaymentProcessorId: '1', DoctorARLocId: '1', PaymentProcessorId: '1', PaymentProcessorName: 'Processor D1 M2', xauditDeleted: false, xauditCreatedBy: 'a', xauditCreatedOn: new Date(), xauditTableRowID: '', xauditModifiedBy: '', xauditModifiedOn: new Date() },
            { LocPaymentProcessorId: '1', DoctorARLocId: '1', PaymentProcessorId: '1', PaymentProcessorName: 'Processor D1 M2', xauditDeleted: false, xauditCreatedBy: 'a', xauditCreatedOn: new Date(), xauditTableRowID: '', xauditModifiedBy: '', xauditModifiedOn: new Date() },
            { LocPaymentProcessorId: '1', DoctorARLocId: '1', PaymentProcessorId: '1', PaymentProcessorName: 'Processor D1 M2', xauditDeleted: false, xauditCreatedBy: 'a', xauditCreatedOn: new Date(), xauditTableRowID: '', xauditModifiedBy: '', xauditModifiedOn: new Date() },
            { LocPaymentProcessorId: '1', DoctorARLocId: '1', PaymentProcessorId: '1', PaymentProcessorName: 'Processor D1 M2', xauditDeleted: false, xauditCreatedBy: 'a', xauditCreatedOn: new Date(), xauditTableRowID: '', xauditModifiedBy: '', xauditModifiedOn: new Date() },
            { LocPaymentProcessorId: '1', DoctorARLocId: '1', PaymentProcessorId: '1', PaymentProcessorName: 'Processor D1 M2', xauditDeleted: false, xauditCreatedBy: 'a', xauditCreatedOn: new Date(), xauditTableRowID: '', xauditModifiedBy: '', xauditModifiedOn: new Date() },
            { LocPaymentProcessorId: '1', DoctorARLocId: '1', PaymentProcessorId: '1', PaymentProcessorName: 'Processor D1 M2', xauditDeleted: false, xauditCreatedBy: 'a', xauditCreatedOn: new Date(), xauditTableRowID: '', xauditModifiedBy: '', xauditModifiedOn: new Date() },
            { LocPaymentProcessorId: '1', DoctorARLocId: '1', PaymentProcessorId: '1', PaymentProcessorName: 'Processor D1 M2', xauditDeleted: false, xauditCreatedBy: 'a', xauditCreatedOn: new Date(), xauditTableRowID: '', xauditModifiedBy: '', xauditModifiedOn: new Date() },
        ];

        const dialogData = this.dialogService.getData();
        if (dialogData !== undefined) {
            this.doctorType = dialogData.doctorType;
            this.setReferralDoctorFromDialog(dialogData);
        }
        else {
            this.route.queryParams.subscribe(params => {
                this.doctorType = params.doctortype;
                this.getDoctorList();
            });

            this.searchPredicate = (data: TdoTableRowModel, filter: string) => {
                if (data.model.dataContact.FirstName?.toLowerCase().includes(filter) || data.model.dataContact.LastName.toLowerCase().includes(filter)) {
                    return true;
                }
            };

            this.sortPredicate = (data: any, sortHeaderId: string): any => {
                switch (sortHeaderId) {
                case 'FirstName':
                    return (data.FirstName?.toLowerCase() + data.LastName?.toLowerCase());
                case 'LastName':
                    return data.LastName?.toLowerCase();
                case 'enumDoctorTypeID':
                    return data.model.isActiveDoctor === true;
                }
            };
        }

        if (this.staticDataService.isReady) {
            this.loadEnums();
        } else {
            this.staticDataService.validValuesReadyEvent.subscribe({
                complete: () => {
                    this.loadEnums();
                }
            });
        }
    }

    loadEnums() {
        this.stateEnums = this.staticDataService.getValidValueItemsByValidValueName('enumStateProvince');
        const tmp = this.staticDataService.getValidValueItemsByValidValueName('enumDoctorType');
        this.doctorTypeEnumList = tmp.filter(p => p.ItemDisplayValue !== 'Default Fee');
        this.getSpecialtyEnumList();  // enum
        this.getWeekDaysEnumList(); // enum
        this.getArSystemIntegrationEnumList(); // enum
        if (this.initialDoctor) {
            this.setDoctor(this.initialDoctor);
        }
    }

    setReferralDoctorFromDialog(dialogData: any) {
        // set values for UI
        this.isFrontDeskReferral = true;
        this.colspan = 5;
        // create new DoctorModel Object
        this.selectedDoctor = new DoctorDataModel();
        this.referralName = dialogData.FirstName;
        this.referralLastName = dialogData.LastName;
        this.referralPhone = dialogData.phone;
        this.referralEmail = dialogData.email;
        this.onNewDoctor();
        this.getAllClientsLocations();
        this.getClientList();
        this.isLoading = false;
        this.dialogService.clearData();
    }

    // Requests
    getDoctorList() {
        this.isLoading = true;
        this.doctorService.getDoctorArAccounts().subscribe((arAccounts) => {
            this.arConfigurationAccounts = arAccounts;

            const doctorsQueryModel = new DoctorQueryOptionsModel();
            if (this.doctorType === this.routeParamsDoctorTypeProviders) {
                doctorsQueryModel.isIncludeTdo = true;
                doctorsQueryModel.isIncludeReferring = false;
            } else {
                doctorsQueryModel.isIncludeTdo = false;
                doctorsQueryModel.isIncludeReferring = true;
            }

            this.doctorList = [];
            this.doctorService.getDoctors(doctorsQueryModel).subscribe((data) => {
                this.doctorList = data;
                if (this.doctorTable) {
                    this.doctorTable.updateData(this.doctorList);
                }
                if (this.doctorList?.length > 0) {
                    const ivl = setInterval(() => {
                        if (this.doctorTable) {
                            this.doctorTable.setSelectedModel(this.doctorList[0]);
                            clearInterval(ivl);
                        }
                    }, 100);
                    if (this.specialtyEnumList?.length > 0)
                    {this.setDoctor(this.doctorList[0]); }
                    else
                    {this.initialDoctor = this.doctorList[0]; }

                    this.getAllClientsLocations();
                    this.getClientList();

                }


                this.userService.getProviderDoctorUsers().subscribe((res) => {
                    this.userList = res;

                    const none = new TdoUserConfigurationModel();
                    none.UserName = 'Clear';
                    this.userList.unshift(none);
                    this.isLoading = false;
                });
                this.isLoading = false;

            });
        });
    }

    getAllClientsLocations() {
        this.doctorService.getAllClientLocations(this.globals.TDOCID).subscribe((locations) => {
            this.allClientsLocations = locations;
        });
    }

    getContactList() {
        this.doctorService.getContacts().subscribe(data => {
            this.doctorContactList = data;
        });
    }

    updateLicenseData(e) {

        this.doctorService.callPutLicense(e.data)
            .subscribe(response => {
            });
    }

    getDocuments() {
        const docIds: string[] = [];
        if (this.selectedDoctor) {
            if (this.selectedDoctor.PortraitDocumentID?.length) {
                docIds.push(this.selectedDoctor.PortraitDocumentID);
            }
            if (this.selectedDoctor.SignatureDocumentID?.length) {
                docIds.push(this.selectedDoctor.SignatureDocumentID);
            }

            this.fileManagerService.getDocuments(docIds).subscribe((res) => {
                this.signatureDocument = res.find(p => p.DocumentID === this.selectedDoctor.SignatureDocumentID);
                this.portraitDocument = res.find(p => p.DocumentID === this.selectedDoctor.PortraitDocumentID);
            });
        }
        else {
            this.signatureDocument = null;
            this.portraitDocument = null;
        }
    }

    onOpenFile(event, propertyName: string) {
        this.lastSelectedLogoPropertyName = propertyName;
        this.fileInput.nativeElement.value = null;
        this.fileInput.nativeElement.click();
    }

    fileSelected(files: FileList) {
        const fileModel = files[0];
        const uploadModel = new DocumentUploadModel();
        uploadModel.blob = fileModel;
        uploadModel.docClassId = DocumentClassEnum.Original;
        uploadModel.docTypeId = DocumentTypeEnum.Scan;
        uploadModel.hasAnnotation = false;
        uploadModel.docTagIds = [];

        this.fileManagerService.uploadDocuments([uploadModel]).subscribe((response) => {
            switch (this.lastSelectedLogoPropertyName) {
            case 'PortraitDocumentID':
                this.portraitDocument = response.documents[0];
                break;
            case 'SignatureDocumentID':
                this.signatureDocument = response.documents[0];
                break;
            }
            this.selectedDoctor[this.lastSelectedLogoPropertyName] = response.documents[0].DocumentID;
            this.onSave(null, false);
        });
    }

    getImageUrl(propertyName: string, document: DocumentDataModel) {
        return this.fileManagerService.getDocumentUrlFromDocument(document);
    }

    checkIsValid() {
        let isValid = true;
        const model = new DoctorSaveValidationModel();
        model.doctor = this.selectedDoctor;
        if (!this.selectedDoctor.dataContact || (this.selectedDoctor.dataContact && !this.selectedDoctor.dataContact.dataAddresses)) {
            isValid = false;
        } else {
            const workAddress = this.selectedDoctor.dataContact.dataAddresses.find(p => p.enumAddressCategoryID === '00000008-1000-0000-0000-000000000002');
            if (workAddress) {
                model.isWorkAddressExists = true;
                if (workAddress.State && workAddress.State.length > 0) {
                    model.isWorkAddressStateExists = true;
                }
                if (workAddress.City && workAddress.City.length > 0) {
                    model.isWorkAddressCityExists = true;
                }
                if (workAddress.PostCode && workAddress.PostCode.length > 0) {
                    model.isWorkAddressZipExists = true;
                }
            } else {
                isValid = false;
            }
        }

        if (!this.selectedDoctor.dataContact || (this.selectedDoctor.dataContact && !this.selectedDoctor.dataContact.dataContactComms)) {
            isValid = false;
        } else {
            const workComm = this.selectedDoctor.dataContact.dataContactComms.find(p => {
                if (p.enumCommLocationID != null) {
                    if (p.enumCommLocationID.toUpperCase() === CommLocationEnum.WORK && (p.enumCommMethodID === CommMethodEnum.Mobile || p.enumCommMethodID === CommMethodEnum.Phone)) {
                        return p;
                    }
                }
            });
            if (workComm) {
                model.isCommRecordExists = true;
                if (workComm.Address && workComm.Address.length > 0) {
                    model.isCommPhoneNumberExists = true;
                }
                if (workComm.isPreferred) {
                    model.isCommMethodPreferredExists = true;
                }
            } else {
                isValid = false;
            }
        }

        if (this.selectedDoctor.dataDoctorSpecialties && this.selectedDoctor.dataDoctorSpecialties.length > 0) {
            model.isSpecialtyExists = true;
        } else {
            isValid = false;
        }

        // Fire dialog
        if (!isValid) {
            const config = new MatDialogConfig();
            config.data = model;
            config.panelClass = 'dialog';
            this.dialog.open(DoctorConfigurationSaveRequirementsDialogComponent, config);
        }

        return isValid;
    }

    onRefLocChange(e, i) {


        i.isSeleted = e.checked;

        this.doctorService.saveDoctorRefLocation(i.RefDoctorId, i.isSeleted).subscribe(res => { });


    }


    onSave(e, isCheckValidity = true) {
        // Gather selected specialties
        // specialtyEnumList
        const dataSpecialties = new Array<DoctorSpecialtyDataModel>();
        for (const specialityEnum of this.specialtyEnumList) {

            const z = this.selectedDoctor.dataDoctorSpecialties.filter(p => p.enumMedicalSpecialtyID === specialityEnum.ValidValueItemId);
            if (z) {
                if (z.length >= 1) {
                    z.forEach(a => {
                        a.xauditDeleted = true;
                    });
                    z[0].xauditDeleted = false;
                }
            }
            const existing = this.selectedDoctor.dataDoctorSpecialties.find(p => p.enumMedicalSpecialtyID === specialityEnum.ValidValueItemId && p.xauditDeleted == false);




            if (existing) {
                existing.xauditDeleted = !specialityEnum.isSelected;
                existing.isPrimary = specialityEnum.isPrimary;
                dataSpecialties.push(existing);
            } else {
                const newSpec = new DoctorSpecialtyDataModel();
                newSpec.DoctorId = this.selectedDoctor.DoctorId;
                newSpec.enumMedicalSpecialtyID = specialityEnum.ValidValueItemId;
                newSpec.isPrimary = specialityEnum.isPrimary;
                newSpec.xauditDeleted = !specialityEnum.isSelected;
                dataSpecialties.push(newSpec);
            }
        }
        this.selectedDoctor.dataDoctorSpecialties = dataSpecialties;
        if (isCheckValidity) {
            if (!this.checkIsValid()) {
                return;
            }
        }
        // Gather selected location workdays
        /// /////////////////////////////////
        // Get all not associated with this location
        const dataLocations = this.selectedDoctor.dataDoctorLocations.filter(p => p.LOCID !== this.selectedClientLocation.LOCID);
        // Add this locations selected days to the list
        if (this.selectedDoctorLocationsByDay !== undefined) {
            for (const enumModel of this.selectedDoctorLocationsByDay) {
                const existingDoctorLocationModel = this.selectedDoctor.dataDoctorLocations.find(p => p.enumWeekDaysId === enumModel.enumWeekDaysId && p.LOCID === enumModel.LOCID);
                if (existingDoctorLocationModel) {
                    dataLocations.push(existingDoctorLocationModel);
                } else {
                    const newDoctorLocationModel = new DoctorLocationDataModel();
                    newDoctorLocationModel.enumWeekDaysId = enumModel.enumWeekDaysId;
                    newDoctorLocationModel.LOCID = this.selectedClientLocation.LOCID;
                    newDoctorLocationModel.DoctorId = this.selectedDoctor.DoctorId;
                    dataLocations.push(newDoctorLocationModel);
                }
            }
        }
        this.selectedDoctor.dataDoctorLocations = dataLocations;

        // Save
        if (this.doctorType === this.routeParamsDoctorTypeProviders) {
            this.selectedDoctor.enumDoctorTypeID = DoctorType_Provider;
        } else {
            // this.selectedDoctor.enumDoctorTypeID = DoctorType_Referring;
        }
        this.doctorService.callPutdataDoctor4CfgDr(this.selectedDoctor.DoctorId === null, this.selectedDoctor)
            .subscribe((response) => {
                this.selectedDoctor = response;
                if (this.isFrontDeskReferral) {
                    this.snackBar.open('Update successful', '', { duration: 5000 });
                    this.dialogRef.close(this.selectedDoctor);
                } else {
                    const idx = this.doctorList.findIndex(p => p.DoctorId === response.DoctorId);
                    if (idx > -1) {
                        this.doctorList[idx] = response;
                    }
                    this.doctorTable.updateData(this.doctorList);
                    // this.doctorTable.updateData();
                    setTimeout(() => {
                        this.doctorTable.setSelectedModel(this.selectedDoctor);
                    }, 200);

                    this.doctorService.saveDoctorPaymentProcessors(this.selectedDoctor.DoctorId, this.doctorArLocationPaymentProcessors).subscribe(
                        (res) => {
                            console.log(res);
                        }
                    );

                    this.snackBar.open('Update successful', '', { duration: 5000 });

                    if (response.enumDoctorTypeID === '00000004-1000-0000-0000-000000000001') {
                        if (response.dataDoctorLocations.length === 0 || response.dataDoctorLicences.length === 0) {
                            const conf = new MatDialogConfig();
                            conf.panelClass = 'dialog';
                            conf.data = response;
                            this.dialog.open(DoctorConfigurationAfterSaveWarningDialogComponent, conf);
                        }
                    }
                }
                this.getDoctorList();
            });
    }

    getClientList() {
        this.doctorService.getClients().subscribe(data => {
            this.clientList = data.sort((a, b) => {
                const aVal = a.Name.toLowerCase();
                const bVal = b.Name.toLowerCase();
                if (aVal < bVal) {
                    return -1;
                }
                if (aVal > bVal) {
                    return 1;
                }
                return 0;
            });

            this.selectedClient = this.clientList[0];
            this.doctorService.getClientLocations(this.selectedClient.TDOCID.toString()).subscribe(ldata => {
                this.locationList = ldata;

                if (this.locationList.length > 0) {
                    this.setLocation(this.locationList[0]);
                }
            });
        }, err => {
            console.log(err);
        });
    }

    onChangeClient(e) {
        if (this.isUnsavedChanges()) {
            this.dialogService.openConfirmDialog(this.unsavedChangesMessage).subscribe((result) => {
                if (result === true) {
                    // Discards changes;
                    this.setClient(e.value);
                } else {
                    // Cancels location change, and puts dropdown / selection back to previous
                    const lastClient = this.selectedClient;
                    const lastLocation = this.selectedClientLocation;
                    this.selectedClient = null;
                    this.selectedClientLocation = null;
                    setTimeout(() => {
                        this.selectedClient = lastClient;
                        this.selectedClientLocation = lastLocation;
                    }, 1);
                }
            });
        } else {
            this.setClient(e.value);
        }
    }

    onLocationSelectionChanged(e) {
        if (this.isUnsavedChanges()) {
            this.dialogService.openConfirmDialog(this.unsavedChangesMessage).subscribe((result) => {
                if (result === true) {
                    // Discards changes;
                    this.setLocation(e.value);
                } else {
                    // Cancels location change, and puts dropdown / selection back to previous
                    const lastLocation = this.selectedClientLocation;
                    this.selectedClientLocation = null;
                    setTimeout(() => {
                        this.selectedClientLocation = lastLocation;
                    }, 1);
                }
            });
        } else {
            this.setLocation(e.value);
        }
    }

    onSelectWeekDay(isSelected: boolean, weekDayEnum: EnumValidValueItemModel) {
        if (isSelected) {
            const locModel = new DoctorLocationDataModel();
            locModel.DoctorId = this.selectedDoctor.DoctorId;
            locModel.LOCID = this.selectedClientLocation.LOCID;
            locModel.enumWeekDaysId = weekDayEnum.ValidValueItemId;
            this.selectedDoctorLocationsByDay.push(locModel);
        } else {
            const idx = this.selectedDoctorLocationsByDay.findIndex(p => p.enumWeekDaysId === weekDayEnum.ValidValueItemId);
            this.selectedDoctorLocationsByDay.splice(idx, 1);
        }
    }

    onLicenceSelectionChanged(e) {
        if (e.selectedRowsData.length > 0) {
            console.log(e.selectedRowsData[0]);
        }
    }

    onRemoveLicense(e) {
        this.doctorService.callRemoveLicense(e.data.LicenceNumberID)
            .subscribe(response => {
                // this.getDoctorList();
            });
    }

    onNewDoctor() {
        this.isNewDoctor = true;
        const doctor = new DoctorDataModel();
        doctor.dataContact = new ContactDataModel();
        doctor.dataDoctorLicences = [];
        doctor.dataDoctorLocations = [];
        doctor.dataDoctorContacts = [];
        doctor.dataDoctorSpecialties = [];
        doctor.DoctorId = '00000000-0000-0000-0000-000000000000';
        doctor.LOCID = parseInt(this.globals.LOCID);
        doctor.dataContact.enumSalutationID = null;
        doctor.dataContact.enumSalutationID = '00000000-0000-0000-0000-000000000000';
        doctor.dataContact.FirstName = '';
        doctor.dataContact.MidName = '';
        doctor.dataContact.LastName = '';
        doctor.ContactId = null;
        doctor.dataContact.enumNameSuffixID = null;
        doctor.enumDoctorTypeID = this.doctorType === this.routeParamsDoctorTypeProviders ? DoctorType_Provider : DoctorType_Referring;
        doctor.enumDoctorClassificationID = null;
        doctor.TaxID = '';
        doctor.DEA = '';
        doctor.xauditDeleted = false;
        doctor.xauditTableRowID = '00000000-0000-0000-0000-000000000000';

        this.signatureDocument = null;
        this.portraitDocument = null;
        if (this.isFrontDeskReferral) { // Set Basic  Info * coming from FrontDesk Referral
            doctor.dataContact.FirstName = this.referralName;
            doctor.dataContact.LastName = this.referralLastName;
        }

        this.doctorService.callPutdataDoctor4CfgDr(true, doctor).subscribe((res) => {
            if (res) {
                this.selectedDoctorsSpecialtyEnumList = [];
                this.selectedARIntegrationEnumList = '';
                this.doctorLicenseList = [];
                this.selectedDoctor = res;
                this.selectedDoctor.dataDoctorLicences = [];
                this.selectedDoctor.dataDoctorLocations = [];
                this.selectedDoctor.dataDoctorContacts = [];
                this.selectedDoctor.dataDoctorSpecialties = [];
                this.selectedDoctor.dataContact = doctor.dataContact;
                this.selectedDoctor.dataContact.ContactId = this.selectedDoctor.ContactId;
                this.selectedWeekDays = [];


                if (this.isFrontDeskReferral) {
                    const dataContactCommPhone = new ContactCommsDataModel();
                    const dataContactCommEmail = new ContactCommsDataModel();

                    dataContactCommPhone.enumCommMethodID = '00000009-1000-0000-0000-000000000001';
                    dataContactCommPhone.Address = this.referralPhone;
                    this.addNewCommunication(res.dataContact.ContactId, dataContactCommPhone);

                    dataContactCommEmail.enumCommMethodID = '00000009-1000-0000-0000-000000000004';
                    dataContactCommEmail.Address = this.referralEmail;
                    this.addNewCommunication(res.dataContact.ContactId, dataContactCommEmail);
                } else {
                    this.doctorList.unshift(res);
                    this.doctorTable.updateData();
                    this.doctorTable.setSelectedModel(res);
                    this.tdoTable.updateData();
                }
            } else {
                console.log('Response undefined');
            }
        });

    }

    // TDO: use this function just when coming from Front Desk Referral
    addNewCommunication(contactId: string, dataContactComm: ContactCommsDataModel) {
        this.patientService.getNewCommForContact(contactId)
            .subscribe((response) => {
                this.isLoading = false;
                if (response) {
                    response.enumCommMethodID = dataContactComm.enumCommMethodID;
                    response.Address = dataContactComm.Address;
                    this.selectedDoctor.dataContact.dataContactComms.push(response);
                } else {
                    console.log('error, no response');
                }
            }, err => {
                console.log('error', err);
            });
    }


    addLicense() {
        const license = new DoctorLicenseDataModel();
        license.DoctorId = this.selectedDoctor.DoctorId;
        this.doctorService.saveLicense(license)
            .subscribe((response) => {
                this.selectedDoctor.dataDoctorLicences.unshift(response);
                this.tdoTable.updateData();
                // this.refreshLicenseTableViewData(this.selectedDoctor.dataDoctorLicences);
            });
    }

    onInitNewRow(e) {
        const z = this.doctorLicenseList[0];
        type t = typeof z;
        const a: t = {} as t;
        a.DoctorId = this.doctorLicenseList[0].DoctorId;
        a.LicenceNumberID = null;
        a.enumLicenceStateID = this.doctorLicenseList[0].enumLicenceStateID;
        this.doctorLicenseList.push(a);
    }

    onEditingStart(e) {

        const z = e.data;
        type t = typeof z;

        const a: t = {} as t;
        a.DoctorId = e.data.DoctorId;
        a.LicenceNumberID = e.data.LicenceNumberID;
        a.enumLicenceStateID = e.data.enumLicenceStateID;
    }

    openEditContact(model: DoctorDataModel) {
        const dm = new PatientDialogDataModel();
        dm.mode = PatientDialogDataModel.MODE_EDIT_CONTACT;
        dm.title = 'Edit Contact';
        dm.entityType = PatientDialogDataModel.TYPE_DOCTOR;
        dm.entity = model;
        dm.entityId = model.DoctorId;
        dm.saveSoloContact = true;
        const dialogRef = this.dialog.open(PatientEditComponent, {
            width: '968px',
            height: '762px',
            panelClass: 'tdo-note-dialog-main',
            data: dm
        });
        dialogRef.afterClosed().subscribe(result => {
            // resolve(result);
            //
        }, err => {
            // reject(err);
        });
    }

    isUnsavedChanges() {
        return false;
    }

    isWeekdayChecked(weekDayEnum: EnumValidValueItemModel) {
        if (this.selectedDoctorLocationsByDay === undefined) {
            return;
        }
        const selected = this.selectedDoctorLocationsByDay.findIndex(p => p.enumWeekDaysId === weekDayEnum.ValidValueItemId);
        return selected !== -1;
    }

    isWeekdayInUseByAnotherLocation(weekDayEnum: EnumValidValueItemModel) {
        if (!this.selectedClientLocation) {
            return;
        }

        const nonSelectedLocations = this.selectedDoctor.dataDoctorLocations.filter(p => p.LOCID !== this.selectedClientLocation.LOCID);
        if (nonSelectedLocations.length > 0) {
            const idx = nonSelectedLocations.findIndex(p => p.enumWeekDaysId === weekDayEnum.ValidValueItemId);
            if (idx > -1) {
                return true;
            }
        }

        return false;
    }


    getLocationWorkingByDay(weekDayEnum: EnumValidValueItemModel) {
        if (!this.selectedClientLocation || !this.allClientsLocations) {
            return;
        }

        const nonSelectedDoctorLocations = this.selectedDoctor.dataDoctorLocations.filter(p => p.LOCID !== this.selectedClientLocation.LOCID);
        if (nonSelectedDoctorLocations.length > 0) {
            const doctorLocationsModel = nonSelectedDoctorLocations.filter(p => p.enumWeekDaysId === weekDayEnum.ValidValueItemId);
            if (doctorLocationsModel) {

                const concatenatedLocations = doctorLocationsModel.map(item => {
                    const matchingClient = this.allClientsLocations.find(obj => obj.LOCID === item.LOCID);
                    if (matchingClient) {
                        const matchLocation = this.clientList.find(p => p.TDOCID === matchingClient.TDOCID && item.LOCID === matchingClient.LOCID);
                        return `${(matchLocation.ShortName !== null && matchLocation.ShortName !== '') ? matchLocation.ShortName : matchLocation.Name} / ${(matchingClient.LocationShortName !== null && matchingClient.LocationShortName !== '') ? matchingClient.LocationShortName : matchingClient.Name}`;
                    }
                }).join(', ');
                return concatenatedLocations !== '' ? `( working at:  ${concatenatedLocations} )` : '';
            }
        }
        return '';

    }

    getTooltip(weekDayEnum: EnumValidValueItemModel) {
        if (!this.selectedClientLocation || !this.allClientsLocations) {
            return;
        }

        const nonSelectedDoctorLocations = this.selectedDoctor.dataDoctorLocations.filter(p => p.LOCID !== this.selectedClientLocation.LOCID);
        if (nonSelectedDoctorLocations.length > 0) {
            const doctorLocationModel = nonSelectedDoctorLocations.find(p => p.enumWeekDaysId === weekDayEnum.ValidValueItemId);
            if (doctorLocationModel) {
                const locationModel = this.allClientsLocations.find(p => p.LOCID === doctorLocationModel.LOCID);
                if (locationModel) {
                    const clientModel = this.clientList.find(p => p.TDOCID === locationModel.TDOCID && doctorLocationModel.LOCID === locationModel.LOCID);
                    if (locationModel && clientModel) {
                        return `Already selected for ${clientModel.Name} practice at ${locationModel.Name} location`;
                    }
                }
            }
        }
        return '';
    }

    setDoctor(model: DoctorDataModel) {
        console.log('setDoctor:', model);
        this.selectedDoctor = model;
        this.lastSelectedRow = model;
        this.getDocuments();
        this.setDoctorARIntegration();
        this.selectedDoctorSpecialties = this.selectedDoctor.dataDoctorSpecialties;
        if (this.selectedDoctorSpecialties.length > 0) {
            this.selectedDoctorsSpecialtyEnumList = this.selectedDoctorSpecialties.map(s => s.enumMedicalSpecialtyID);

            this.specialtyEnumList.forEach(a => {
                a.isSelected = false;
                a.isPrimary = false;
            });

            this.selectedDoctorSpecialties.forEach(s => {

                const z = this.specialtyEnumList.find((f) => f.ValidValueItemId == s.enumMedicalSpecialtyID);

                if (z) {
                    z.isPrimary = s.isPrimary;
                    z.isSelected = true;

                    if (z.isPrimary == true) { this.selected = this.specialtyEnumList.findIndex((f) => f.ValidValueItemId == s.enumMedicalSpecialtyID); }


                }
            });
        }
        if (this.selectedClientLocation) {
            this.selectedDoctorLocationsByDay = this.selectedDoctor.dataDoctorLocations.filter(p => p.LOCID === this.selectedClientLocation.LOCID);
        }
    }

    setClient(model: TdoClientConfigurationModel) {
        this.selectedClient = model;
        this.doctorService.getClientLocations(this.selectedClient.TDOCID.toString()).subscribe((ldata) => {
            this.locationList = ldata;
            if (this.locationList.length > 0) {
                this.setLocation(this.locationList[0]);
            }
        }, err => {
            console.log(err);
        });
    }

    setLocation(model: ClientLocationDataModel) {
        this.selectedClientLocation = model;

        this.loadlocaionPaymentProcessors();

        if (this.selectedDoctor.dataDoctorLocations !== undefined) {
            this.selectedDoctorLocationsByDay = this.selectedDoctor.dataDoctorLocations.filter(p => p.LOCID === this.selectedClientLocation.LOCID);
        }
        this.setDoctorARIntegration();
    }

    // Enums
    getSpecialtyEnumList() {
        this.doctorService.callGetenumValidValueItems('enumMedicalSpecialty').subscribe(data => {
            // this.specialtyEnumList = data;

            this.specialtyEnumList = [];
            data.forEach(s => {
                const v = {} as EnumPaymentProcessorModel;
                v.ValidValueItemId = s.ValidValueItemId;
                v.ValidValueId = s.ValidValueId;
                v.ItemDisplayValue = s.ItemDisplayValue;
                v.isSelected = false;   // s.isSelected;
                if (s.isPrimary) {
                    v.isPrimary = s.isPrimary;
                }
                else {
                    v.isPrimary = false;
                }
                this.specialtyEnumList.push(v);
            }
            );
        });
    }

    getWeekDaysEnumList() {
        this.doctorService.callGetenumValidValueItems('enumWeekDays').subscribe(data => {
            this.weekDaysEnumList = data;
        });
    }

    getArSystemIntegrationEnumList() {
        this.doctorService.callGetenumValidValueItems('enumARSystemIntegration').subscribe(data => {
            this.arIntegrationEnumList = data;
        });
    }

    onUserSelectionChange(event: TdoUserConfigurationModel) {
        this.selectedDoctor.UserId = event.UserID;
    }

    getUser() {
        if (this.userList && this.userList.length > 0) {
            const usr = this.userList.find(p => p.UserID === this.selectedDoctor.UserId);
            if (usr) {
                return usr;
            }
        }
        return null;
    }

    resetCredentials() {
        if (!this.checkIsValid()) {
            return;
        }
        this.dialogService.openConfirmDialog(`Are you sure you want to reset credentials for Dr. ${this.selectedDoctor.dataContact.LastName}`).subscribe((res) => {
            if (res) {
                this.isLoading = true;
                this.isResettingCredentials = true;
                const refDoctorUser = {
                    UserName: this.selectedDoctor.UserName,
                    FirstName: this.selectedDoctor.dataContact.FirstName,
                    LastName: this.selectedDoctor.dataContact.LastName,
                    FullName: this.selectedDoctor.dataContact.FirstName + ' ' + this.selectedDoctor.dataContact.LastName,
                    UserID: this.selectedDoctor.UserId,
                    ContactId: this.selectedDoctor.ContactId,
                    LoginUrl: location.origin + '/referrerLogin',
                    BaseUrl: location.origin,
                    DoctorId: this.selectedDoctor.DoctorId
                };

                this.doctorService.resetReferrerDoctorCredentials(refDoctorUser).subscribe((response) => {
                    this.isLoading = false;
                    this.isResettingCredentials = false;
                    if (response) {
                        this.selectedDoctor.UserId = response.UserId;
                        this.selectedDoctor.UserName = response.Username;
                        this.onSave(null, false);
                        this.showMessage('Success', `User credentials changed. Password Assigned : ${response.Message}`, 10000);

                    }
                },
                err => {
                    this.isLoading = false;
                    console.log(err);
                    this.showMessage('Error', `Error modifying credentials : ${err.error.ExceptionMessage ?? err.error.Message ?? err.error}`, 5000);
                });

            }

        });
    }

    showMessage(type, message, duration = 3000) {
        this.snackBar.open(message, type, {
            duration,
            verticalPosition: 'top'
        });
    }

    onLicenseEditComplete(event: TdoTableEvent) {
    }

    onLicenseInputFinished(event: any, row: TdoTableRowModel) {
        const license = row.model as DoctorLicenseDataModel;
        this.doctorService.saveLicense(license)
            .subscribe((response) => {
            });
    }

    deleteLicense(model: DoctorLicenseDataModel) {
        let deleteMessage = 'Are you sure you want to delete the selected row?';
        if (model.LicenceNumber) {
            deleteMessage = `Are you sure you want to delete license ${model.LicenceNumber}?`;
        }
        this.dialogService.openConfirmDialog(deleteMessage).subscribe((result) => {
            if (result) {
                this.doctorService.deleteLicense(model).subscribe(() => {
                    const idx = this.selectedDoctor.dataDoctorLicences.findIndex(p => p.LicenceNumberID === model.LicenceNumberID);
                    if (idx > -1) {
                        this.selectedDoctor.dataDoctorLicences.splice(idx, 1);
                        this.tdoTable.updateData();
                    }
                });
            }
        });
    }

    onLicenseStateChange(event: string, row: TdoTableRowModel) {
        row.model.enumLicenceStateID = event;
        this.doctorService.saveLicense(row.model)
            .subscribe((response) => {

            });
    }

    onInput() {
    }

    onTdoTableItemClick1(event: TdoTableSelectionEvent) {
        if (this.isUnsavedChanges()) {
            this.dialogService.openConfirmDialog(this.unsavedChangesMessage).subscribe((result) => {
                if (result === true) {
                    // Discards changes;
                    this.setDoctor(event.row.model);
                    this.tdoTable.updateData();
                } else {
                    // Cancels change
                    // this.selection.select(this.lastSelectedRow);
                    this.doctorTable.setSelectedModel(this.lastSelectedRow);
                }
            });
        } else {
            this.setDoctor(event.row.model);
            if (this.tdoTable) {
                this.tdoTable.updateData();
            }
            setTimeout(() => {
                if (this.tdoTable) {
                    this.tdoTable.updateData();
                }
            }, 100);
        }
    }

    onDeleteDoctor(row: TdoTableRowModel, event: MouseEvent) {
        event.stopImmediatePropagation();
        const model = row.model;
        this.dialogService.openConfirmDialog(`Are you sure you want to delete ${model.dataContact.FirstName} ${model.dataContact.LastName}?`).subscribe((result) => {
            if (result === true) {
                this.doctorService.callRemoveDoctor(model.DoctorId)
                    .subscribe(response => {
                        const idx = this.doctorList.findIndex(p => p === model);
                        if (idx > -1) {
                            this.doctorList.splice(idx, 1);
                            this.doctorTable.updateData();
                            this.snackBar.open(`Successfully deleted ${model.dataContact.FirstName} ${model.dataContact.LastName}`, '', { duration: 5000 });
                        }
                    });
            } else {
                //
            }
        });
    }

    setDoctorARIntegration() {
        this.isQuickbooksIntegration = false;
        this.selectedDoctorARLocation = null;
        this.selectedARIntegrationEnumList = '';
        if (this.selectedDoctor?.dataDoctorARLocations && this.selectedClientLocation) {
            const arLoc = this.selectedDoctor.dataDoctorARLocations.find(p => p.LOCID === this.selectedClientLocation.LOCID);
            if (arLoc) {
                this.selectedDoctorARLocation = arLoc;
                this.selectedARIntegrationEnumList = arLoc.enumARSystemIntegrationID;
                this.loadDoctorsPaymentProcessors();
            }
        }
        this.setSelectedDoctorArAccount();
        this.loadArIntegrationJSON();
    }

    setSelectedDoctorArAccount() {
        if (this.selectedDoctorARLocation) {
            const cfg = this.arConfigurationAccounts.find(p => p.ARAccountID === this.selectedDoctorARLocation.ARAccountID);
            if (cfg) {
                this.selectedArAccountConfig = cfg;
            } else {
                this.selectedArAccountConfig = null;
            }
        } else {
            this.selectedArAccountConfig = null;
        }

      if (this.selectedDoctorARLocation) {
        const cfg = this.arConfigurationAccounts.find(p => p.ARAccountID === this.selectedDoctorARLocation.ARCheckAccountID);
        if (cfg) {
          this.selectedArCheckAccountConfig = cfg;
        } else {
          this.selectedArCheckAccountConfig = null;
        }
      } else {
        this.selectedArCheckAccountConfig = null;
      }


    }

    onSelectedArAccountChanged(event: MatSelectChange) {
        this.selectedArAccountConfig = event.value as ArAccountConfigurationModel;
        if (this.selectedDoctorARLocation) {
            this.selectedDoctorARLocation.ARAccountID = this.selectedArAccountConfig.ARAccountID;
        } else {
            this.selectedDoctorARLocation = new DoctorArLocationDataModel();
            this.selectedDoctorARLocation.DoctorId = this.selectedDoctor.DoctorId;
            this.selectedDoctorARLocation.LOCID = this.selectedClientLocation.LOCID;
            this.selectedDoctorARLocation.ARAccountID = this.selectedArAccountConfig.ARAccountID;
            this.selectedDoctor.dataDoctorARLocations.push(this.selectedDoctorARLocation);
        }
    }
    onSelectedCheckAccountChanged(event: MatSelectChange) {
        this.selectedArCheckAccountConfig = event.value as ArAccountConfigurationModel;
        if (this.selectedDoctorARLocation) {
            this.selectedDoctorARLocation.ARCheckAccountID = this.selectedArCheckAccountConfig.ARAccountID;
        } else {
            this.selectedDoctorARLocation = new DoctorArLocationDataModel();
            this.selectedDoctorARLocation.DoctorId = this.selectedDoctor.DoctorId;
            this.selectedDoctorARLocation.LOCID = this.selectedClientLocation.LOCID;
            this.selectedDoctorARLocation.ARCheckAccountID = this.selectedArCheckAccountConfig.ARAccountID;
            this.selectedDoctor.dataDoctorARLocations.push(this.selectedDoctorARLocation);
        }
    }
    onSelectedEnumARIntegrationID(event: MatSelectChange) {
        this.selectedARIntegrationEnumList = event.value as string;
        if (this.selectedDoctorARLocation) {
            this.selectedDoctorARLocation.enumARSystemIntegrationID = this.selectedARIntegrationEnumList;
        } else {
            this.selectedDoctor.dataDoctorARLocations.push(this.selectedDoctorARLocation);
        }
        this.loadArIntegrationJSON();
    }

    loadArIntegrationJSON() {
        if (this.selectedDoctorARLocation) {
            this.isQuickbooksIntegration = this.selectedDoctorARLocation.enumARSystemIntegrationID === ArIntegration_QuickBooks;

            if (this.isQuickbooksIntegration) {
                this.loadQuickBooksFromJSON();
            } else {
                this.selectedQuickBooks = new DoctorArLocationQuickbooksModel();
                this.selectedQBSalesAccount = null;
                this.selectedQBCheckingAccount = null;
            }
        } else {
            this.isQuickbooksIntegration = false;
            this.selectedQuickBooks = new DoctorArLocationQuickbooksModel();
            this.selectedQBSalesAccount = null;
            this.selectedQBCheckingAccount = null;
        }
    }

    loadQuickBooksFromJSON() {
        if (this.selectedDoctorARLocation.ARSystemIntegrationJSON) {
            this.selectedQuickBooks = JSON.parse(this.selectedDoctorARLocation.ARSystemIntegrationJSON) as DoctorArLocationQuickbooksModel;
        } else {
            this.selectedQuickBooks = new DoctorArLocationQuickbooksModel();
        }
        if (this.selectedDoctorARLocation.ARSystemIntegrationStart === null) {
            this.selectedDoctorARLocation.ARSystemIntegrationStart = new Date();
        }
        this.setSelectedQBSalesAccount();
        this.setSelectedQBCheckingAccount();
    }

    setSelectedQBSalesAccount() {
        if (this.selectedDoctorARLocation && this.selectedDoctorARLocation.ARSalesAccountID) {
            const cfgSales = this.arConfigurationAccounts.find(p => p.ARAccountID === this.selectedDoctorARLocation.ARSalesAccountID);
            if (cfgSales) {
                this.selectedQBSalesAccount = cfgSales;
            } else {
                this.selectedQBSalesAccount = null;
            }
        } else {
            this.selectedQBSalesAccount = null;
        }
    }

    setSelectedQBCheckingAccount() {
        if (this.selectedDoctorARLocation?.ARCheckAccountID) {
            const cfgSales = this.arConfigurationAccounts.find(p => p.ARAccountID === this.selectedDoctorARLocation.ARCheckAccountID);
            if (cfgSales) {
                this.selectedQBCheckingAccount = cfgSales;
            } else {
                this.selectedQBCheckingAccount = null;
            }
        } else {
            this.selectedQBCheckingAccount = null;
        }
    }

    onSelectedQBSalesAccount(event: MatSelectChange) {
        this.selectedQBSalesAccount = event.value as ArAccountConfigurationModel;
        this.selectedDoctorARLocation.ARSalesAccountID = this.selectedQBSalesAccount.ARAccountID;
        this.quickBooksChange();
    }

    onSelectedQBCheckingAccount(event: MatSelectChange) {
        this.selectedQBCheckingAccount = event.value as ArAccountConfigurationModel;
        this.selectedDoctorARLocation.ARCheckAccountID = this.selectedQBCheckingAccount.ARAccountID;
        this.quickBooksChange();
    }

    quickBooksChange() {
        if (this.selectedQuickBooks) {
            this.selectedDoctorARLocation.ARSystemIntegrationJSON = JSON.stringify(this.selectedQuickBooks);
        } else {
            this.selectedDoctorARLocation.ARSystemIntegrationJSON = null;
        }
    }

    onDoctorStatusChange(event: MatCheckboxChange, model: DoctorDataModel) {
        model.isActiveDoctor = event.checked;
        this.doctorService.changeDoctorActivityStatus(model).subscribe((res) => {
            const idx = this.doctorList.findIndex(p => p.DoctorId === res.DoctorId);
            if (idx > -1) {
                this.selectedDoctor = res;
                this.doctorList[idx] = res;
                this.doctorTable.updateData(this.doctorList);
            }
        });
    }

    onAddPaymentProcessorVisible(row: any, $event: MouseEvent) {


        this.isPaymentProcessorVisible = !this.isPaymentProcessorVisible;


    }


    onNgModelChangecfgARPaymentProcessors(e: any, p: any) { //  e: MatSelectionListChange )  {
        this.selectedPaymentProcessor = p;
    }

    onAddPaymentProcessor() {
        this.doctorArLocationPaymentProcessors.push(

            {
                LocPaymentProcessorId: '00000000-0000-0000-0000-000000000000',
                DoctorARLocId: this.selectedDoctorARLocation.DoctorARLocId,
                PaymentProcessorId: this.selectedPaymentProcessor.PaymentProcessorId,
                PaymentProcessorName: this.selectedPaymentProcessor.Name,
                xauditDeleted: false,
                xauditCreatedBy: 'a', xauditCreatedOn: new Date(), xauditTableRowID: '', xauditModifiedBy: '', xauditModifiedOn: new Date()
            }

        );

        this.isPaymentProcessorVisible = false;
    }

    onDeletePaymentProcessor(row: any, $event: MouseEvent) {
        this.doctorArLocationPaymentProcessors.find(f =>
            f.PaymentProcessorId == row.PaymentProcessorId).xauditDeleted = true;
    }


    private loadDoctorsPaymentProcessors() {
        this.doctorService.getDoctorArDoctorPaymentProcessors(this.selectedDoctorARLocation.DoctorARLocId).subscribe((data) => {
            this.doctorArLocationPaymentProcessors = data;
        });
    }


    private loadlocaionPaymentProcessors() {
        this.doctorService.getPaymentProcessors(this.selectedClientLocation.LOCID).subscribe((data) => {
            this.cfgARPaymentProcessors = data;
        });
    }
}
